import * as React from 'react';
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import { Context } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { Hooks } from '@grandvisionhq/payments';
import { useIntl } from '@grandvisionhq/state';
import { convertCentsToDecimalString } from '@grandvisionhq/utils';
import { mapCartPaymentMethods } from '../mappers/apple-pay-payment-methods.js';
import { useMapShippingContact } from '../utility-hooks/use-map-shipping-contact.js';
import { useRequiredContactFields } from '../utility-hooks/use-required-contact-fields.js';
import { CheckoutErrorsMapping } from '../../../../../mappers/errors-mapping.js';
import { useCheckoutSettings } from '../../../../../context/CheckoutSettings/context.js';

var ShippingContactEditingMode;
(function(ShippingContactEditingMode) {
    ShippingContactEditingMode["STORE_PICKUP"] = 'storePickup';
    ShippingContactEditingMode["DEFAULT"] = 'enabled';
})(ShippingContactEditingMode || (ShippingContactEditingMode = {}));
const useCreatePaymentRequest = ()=>{
    var ref4;
    const { country , currency  } = useIntl();
    const [getCartExpressPaymentMethods, paymentMethodsResult] = Hooks.useGetCartExpressPaymentMethods();
    const { cart  } = Context.useCart();
    const requiredContactFields = useRequiredContactFields();
    const { shippingContact , shippingContactEditingMode , shippingType  } = useMapShippingContact(cart);
    const { payments  } = useCheckoutSettings();
    const [error, setError] = React.useState(undefined);
    var ref1;
    const expressPaymentMethods = React.useMemo(()=>{
        return (ref1 = paymentMethodsResult === null || paymentMethodsResult === void 0 ? void 0 : paymentMethodsResult.data) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        paymentMethodsResult === null || paymentMethodsResult === void 0 ? void 0 : paymentMethodsResult.data
    ]);
    React.useEffect(()=>{
        if (cart === null || cart === void 0 ? void 0 : cart.id) {
            getCartExpressPaymentMethods(cart.id);
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        getCartExpressPaymentMethods
    ]);
    const createPaymentRequest = React.useCallback(()=>{
        var ref, ref2, ref3;
        if (!(cart === null || cart === void 0 ? void 0 : cart.id)) {
            console.error('No cart available.');
            setError(CheckoutErrorsMapping.CartIdNotFound);
            toast.failed(CheckoutErrorsMapping.CartIdNotFound);
            return;
        }
        if (!(paymentMethodsResult === null || paymentMethodsResult === void 0 ? void 0 : paymentMethodsResult.data)) {
            console.error('No payment methods available.');
            setError(CheckoutErrorsMapping.PaymentMethodNotFound);
            toast.failed(CheckoutErrorsMapping.PaymentMethodNotFound);
            return;
        }
        if (!(payments === null || payments === void 0 ? void 0 : (ref = payments.applePay) === null || ref === void 0 ? void 0 : ref.merchantName)) {
            console.error('No merchant name available.');
        }
        const totalPrice = cart === null || cart === void 0 ? void 0 : (ref2 = cart.prices) === null || ref2 === void 0 ? void 0 : ref2.totalPrice;
        const total = {
            label: (payments === null || payments === void 0 ? void 0 : (ref3 = payments.applePay) === null || ref3 === void 0 ? void 0 : ref3.merchantName) || 'GrandVision N.V.',
            amount: convertCentsToDecimalString(totalPrice),
            type: 'final'
        };
        const merchantCapabilities = new Array('supports3DS');
        const paymentRequest = {
            requiredShippingContactFields: requiredContactFields,
            requiredBillingContactFields: requiredContactFields,
            countryCode: country,
            currencyCode: currency,
            merchantCapabilities,
            total,
            supportedNetworks: mapCartPaymentMethods(expressPaymentMethods),
            shippingContact,
            shippingType,
            shippingContactEditingMode
        };
        // remove all undefined properties and return
        return pickBy(paymentRequest, identity);
    }, [
        cart,
        paymentMethodsResult === null || paymentMethodsResult === void 0 ? void 0 : paymentMethodsResult.data,
        payments === null || payments === void 0 ? void 0 : (ref4 = payments.applePay) === null || ref4 === void 0 ? void 0 : ref4.merchantName,
        requiredContactFields,
        country,
        currency,
        expressPaymentMethods,
        shippingContact,
        shippingType,
        shippingContactEditingMode, 
    ]);
    return [
        createPaymentRequest,
        {
            error,
            loading: paymentMethodsResult.loading || false
        }, 
    ];
};

export { useCreatePaymentRequest };
//# sourceMappingURL=use-create-payment-request.js.map
